import React from "react";
import { GoogleMap, LoadScript, Marker, InfoWindow } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px",
  position: "relative",
};

const center = {
  lat: 43.8563,
  lng: 18.4131,
};

const Map = ({ locations }) => {
  const [selectedMarker, setSelectedMarker] = React.useState(null);

  const getMarkerIcon = (status) => {
    return status === "Online"
      ? "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
      : "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
  };

  // Calculate statistics
  const totalScreens = locations.length;
  const onlineScreens = locations.filter((loc) => loc.status === "Online").length;
  const offlineScreens = locations.filter((loc) => loc.status === "Offline").length;

  return (
    <div style={{ position: "relative", width: "100%", height: "400px" }}>
      <LoadScript googleMapsApiKey="AIzaSyBDnuICzZqRTPnnDnFrUXOn3boeoDdBY5o">
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={8}>
          {locations.map((location) => (
            <Marker
              key={location.id}
              position={{ lat: location.lat, lng: location.lng }}
              icon={getMarkerIcon(location.status)}
              onClick={() => setSelectedMarker(location)}
            />
          ))}

          {selectedMarker && (
            <InfoWindow
              position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
              onCloseClick={() => setSelectedMarker(null)}
            >
              <div>
                <h4>{selectedMarker.name}</h4>
                <p>Status: {selectedMarker.status}</p>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      </LoadScript>

      {/* Stats Card */}
      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          padding: "15px",
          borderRadius: "8px",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
          zIndex: 10,
        }}
      >
        <h4>Screen Stats</h4>
        <p><strong>Total Screens:</strong> {totalScreens}</p>
        <p><strong>Online Screens:</strong> {onlineScreens}</p>
        <p><strong>Offline Screens:</strong> {offlineScreens}</p>
      </div>
    </div>
  );
};

export default Map;
